module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cc-history",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm._l((_vm.filteredHistoryCalls), function(history) {
    return _c('cc-history-item', {
      staticClass: "panel cc-panel-default",
      class: {
        active: _vm.isHistoryFromUserCaller(history)
      },
      attrs: {
        "history": history
      },
      on: {
        "update": _vm.onUpdate
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.historyCalls.length),
      expression: "!historyCalls.length"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Keine Calls in der History gefunden")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ee733fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/History.vue
// module id = 262
// module chunks = 0